<div class="alerts-list">
  <div class="header-bar">
    <emt-delta-icon iconName="icon-bell" [fill]="'black'"></emt-delta-icon>
    <span class="header-title">Notifications</span>
    <span class="notification-count">{{ (alerts$ | async)?.length }}</span>
    <emt-delta-icon class="settings-button" iconName="icon-settings" [fill]="'black'"></emt-delta-icon>
  </div>
  <div class="alert-items">
    @for (alert of alerts$ | async; track alertTrackByFn($index, alert)) {
      <div class="alert-item" [ngClass]="alert.severity.toLowerCase()">
        @if (alert.severity === 'LOW') {
          <span class="no-priority"></span>
        }
        @if (alert.severity !== 'LOW') {
          <emt-delta-icon
            class="priority-icon"
            [width]="'18px'"
            [height]="'18px'"
            [fill]="getAlertColor(alert)"
            iconName="icon-error"
          ></emt-delta-icon>
        }
        @if (alert.severity !== 'LOW') {
          <span class="priority" [ngClass]="alert.severity.toLowerCase()">{{ alert.severity }} priority</span>
        }
        <span class="date">{{ showTime(alert.createDateTime) }}</span>
        <div class="title">{{ alert.station ? alert.station : alert.flightNumber }}</div>
        <div class="content">{{ alert.message }}</div>
      </div>
    }
  </div>
</div>
